// import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';

import { NgModule } from '@angular/core';
import { EmailTokenComponent } from '../eamil-token/email-token.component';
import { UserProfileComponent } from './user-profile.component';

@NgModule({
  declarations: [],
  exports: [UserProfileComponent, EmailTokenComponent],
  imports: [
    UserProfileComponent, 
    EmailTokenComponent
  ],
})
export class UserProfileModule {}
